// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CirclePlaceholder__container-ac71cc {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Placeholders/CirclePlaceholder/CirclePlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF","sourcesContent":[".container {\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CirclePlaceholder__container-ac71cc`
};
module.exports = ___CSS_LOADER_EXPORT___;
